import React from "react";
import classNames from "classnames";
import { capitalize } from "lodash";
import Chip from "./Chip";
import { OrderDisplayFinancialStatus } from "gpc-shared-types";

export type Props = {
  status: OrderDisplayFinancialStatus;
  className?: string;
};

const getStatusLabel = (status: OrderDisplayFinancialStatus) => {
  switch (status) {
    case OrderDisplayFinancialStatus.PENDING:
      return "Unpaid";

    default:
      return capitalize(status.replace("_", " "));
  }
};

const getStatusColor = (status: OrderDisplayFinancialStatus) => {
  switch (status) {
    case OrderDisplayFinancialStatus.PENDING:
      return "danger";
    case OrderDisplayFinancialStatus.PARTIALLY_PAID:
      return "warning";
    case OrderDisplayFinancialStatus.PAID:
      return "success";

    default:
      return;
  }
};

export const PaymentStatus = ({ status, className = "" }: Props) => {
  const internalClassName = classNames("gpc__payment-status", className);

  return (
    <div className={internalClassName}>
      <Chip label={getStatusLabel(status)} color={getStatusColor(status)} />
    </div>
  );
};

export default PaymentStatus;
